import { createBrowserHistory, createHashHistory } from "history";

export const history = createBrowserHistory();
export const hashHistory = createHashHistory();
